import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Link, TextField, useTheme } from '@mui/material';

import asmubip from '../assets/images/logoASMUBIP5.png';
import logo from '../assets/images/LOGO-APP-312.png';
import footer from '../assets/images/assinatura-serpro.png';

import { Layout } from 'src/styles';
import { LoginPage, SpaceBetweenHolder } from 'src/styles/styledComponents';
import AsmubipButton from 'src/components/AsmubipButton';

export default function PasswordReset() {
  const theme = useTheme();
  const [submitted, setSubmitted] = useState(false);
  const [selection, setSelection] = useState<'mail' | 'phone' | null>(null);
  //   const [payload, setPayload] = useState('');

  const handleSelectionMail = () => {
    setSelection('mail');
  };

  const handleSelectionPhone = () => {
    setSelection('phone');
  };

  const handleSubmit = () => {
    // if (selection === 'mail') {
    // } else if (selection === 'phone') {
    // }
    setSubmitted(true);
  };

  return (
    <LoginPage>
      <SpaceBetweenHolder>
        <Box sx={{ padding: '20px' }}>
          <img src={asmubip} />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '40px' }}>
          <img src={logo} />
          {!submitted && !selection && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box
                sx={{
                  textAlign: 'center',
                  fontSize: '24px',
                  color: theme.palette.primary.contrastText,
                }}>
                Enviar nova senha para e-mail ou telefone?
              </Box>

              <Box sx={{ display: 'flex', gap: '8px', marginTop: '40px', marginBottom: '40px' }}>
                <AsmubipButton variant="contained" size="medium" onClick={handleSelectionMail}>
                  E-mail
                </AsmubipButton>
                <AsmubipButton
                  variant="contained-dark"
                  size="medium"
                  onClick={handleSelectionPhone}>
                  Telefone
                </AsmubipButton>
              </Box>
              <Link href="/login" sx={{ color: theme.palette.primary.contrastText }}>
                Voltar
              </Link>
            </Box>
          )}

          {!submitted && selection && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <TextField
                margin="dense"
                id="payload"
                label={selection == 'mail' ? 'Email' : 'Telefone'}
                type="text"
                variant="filled"
                sx={{ ...Layout.loginInput, width: '300px' }}
                onKeyUp={(e) => {
                  if (e.code === 'Enter') {
                    handleSubmit();
                  }
                }}
                //   onChange={(e) => {
                //     setPayload(e.target.value);
                //   }}
                // error={status !== null && status !== 'failed' && !!status.error.password}
                // helperText={status !== null && status !== 'failed' && status.error.password}
              />
              <AsmubipButton
                variant="contained"
                size="large"
                onClick={handleSubmit}
                sx={{ marginTop: '40px', marginBottom: '40px' }}>
                Enviar
              </AsmubipButton>
              <Box
                sx={{ color: theme.palette.primary.contrastText }}
                onClick={() => {
                  setSelection(null);
                }}>
                Voltar
              </Box>
            </Box>
          )}

          {submitted && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box
                sx={{
                  textAlign: 'center',
                  fontSize: '24px',
                  color: theme.palette.primary.contrastText,
                }}>
                Pronto!
              </Box>
              <Box
                sx={{
                  textAlign: 'center',
                  fontSize: '24px',
                  color: theme.palette.primary.contrastText,
                }}>
                Enviamos uma nova senha para o seu contato
              </Box>
              <Link href="/login">
                <AsmubipButton
                  variant="contained"
                  size="large"
                  sx={{ marginTop: '40px', marginBottom: '40px' }}>
                  Voltar
                </AsmubipButton>
              </Link>
              <Link href="/#" sx={{ color: theme.palette.primary.contrastText }}>
                Ainda preciso de ajuda
              </Link>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            backgroundColor: 'white',
            display: 'flex',
            padding: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: 'unset !important',
            width: '100%',
          }}>
          <img src={footer} />
        </Box>
      </SpaceBetweenHolder>
    </LoginPage>
  );
}
